import React, { useState, useEffect } from 'react';
import axios from 'axios';

const API = 'https://app.b3rastreamento.com.br/api';

function RedefinirSenha() {
  const [token, setToken] = useState('');
  const [novaSenha, setNovaSenha] = useState('');
  const [confirmarSenha, setConfirmarSenha] = useState('');
  const [carregando, setCarregando] = useState(false);
  const [validando, setValidando] = useState(true);
  const [tokenValido, setTokenValido] = useState(false);
  const [mensagem, setMensagem] = useState('');
  const [sucesso, setSucesso] = useState(false);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const t = params.get('token');
    if (!t) {
      setValidando(false);
      setTokenValido(false);
      return;
    }
    setToken(t);
    axios.get(`${API}/senha/validar/${t}`)
      .then(() => { setTokenValido(true); setValidando(false); })
      .catch(() => { setTokenValido(false); setValidando(false); });
  }, []);

  const redefinir = async (e) => {
    e.preventDefault();
    if (novaSenha !== confirmarSenha) {
      setMensagem('As senhas não conferem.');
      return;
    }
    if (novaSenha.length < 6) {
      setMensagem('A senha deve ter pelo menos 6 caracteres.');
      return;
    }
    setCarregando(true);
    setMensagem('');
    try {
      await axios.post(`${API}/senha/redefinir`, { token, nova_senha: novaSenha });
      setSucesso(true);
    } catch (err) {
      setMensagem(err.response?.data?.erro || 'Erro ao redefinir senha. Tente novamente.');
    }
    setCarregando(false);
  };

  return (
    <div style={{ minHeight: '100vh', background: 'linear-gradient(135deg, #1a1a2e 0%, #16213e 50%, #0f3460 100%)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px' }}>
      <div style={{ width: '100%', maxWidth: '420px' }}>
        <div style={{ textAlign: 'center', marginBottom: '32px' }}>
          <div style={{ fontSize: '48px', marginBottom: '12px' }}>🛰️</div>
          <h1 style={{ color: 'white', fontSize: '28px', fontWeight: '700', margin: 0 }}>LocTracker</h1>
          <p style={{ color: 'rgba(255,255,255,0.6)', margin: '8px 0 0', fontSize: '14px' }}>Rastreamento Veicular</p>
        </div>

        <div style={{ background: 'white', borderRadius: '16px', padding: '32px', boxShadow: '0 20px 60px rgba(0,0,0,0.3)' }}>
          {validando ? (
            <div style={{ textAlign: 'center', color: '#999', padding: '20px' }}>
              <div style={{ fontSize: '32px', marginBottom: '12px' }}>⏳</div>
              Validando link...
            </div>
          ) : !tokenValido ? (
            <div style={{ textAlign: 'center' }}>
              <div style={{ fontSize: '48px', marginBottom: '16px' }}>❌</div>
              <h2 style={{ color: '#A32D2D', fontSize: '18px', marginBottom: '12px' }}>Link inválido ou expirado</h2>
              <p style={{ color: '#666', fontSize: '13px', marginBottom: '20px' }}>Este link de redefinição não é mais válido. Solicite um novo.</p>
              <button onClick={() => window.location.href = '/login'}
                style={{ width: '100%', padding: '12px', background: '#1D9E75', color: 'white', border: 'none', borderRadius: '8px', fontSize: '14px', cursor: 'pointer', fontWeight: '600' }}>
                Voltar ao login
              </button>
            </div>
          ) : sucesso ? (
            <div style={{ textAlign: 'center' }}>
              <div style={{ fontSize: '48px', marginBottom: '16px' }}>✅</div>
              <h2 style={{ color: '#0F6E56', fontSize: '18px', marginBottom: '12px' }}>Senha redefinida!</h2>
              <p style={{ color: '#666', fontSize: '13px', marginBottom: '20px' }}>Sua senha foi atualizada com sucesso. Você já pode fazer login.</p>
              <button onClick={() => window.location.href = '/login'}
                style={{ width: '100%', padding: '12px', background: '#1D9E75', color: 'white', border: 'none', borderRadius: '8px', fontSize: '15px', cursor: 'pointer', fontWeight: '600' }}>
                🚀 Ir para o login
              </button>
            </div>
          ) : (
            <>
              <h2 style={{ margin: '0 0 8px', fontSize: '20px', color: '#333', textAlign: 'center' }}>🔐 Nova senha</h2>
              <p style={{ color: '#999', fontSize: '13px', textAlign: 'center', marginBottom: '24px' }}>Digite e confirme sua nova senha.</p>
              <form onSubmit={redefinir}>
                <div style={{ marginBottom: '16px' }}>
                  <label style={{ fontSize: '13px', color: '#666', fontWeight: '600', display: 'block', marginBottom: '6px' }}>Nova senha</label>
                  <input type="password" placeholder="Mínimo 6 caracteres" value={novaSenha}
                    onChange={e => setNovaSenha(e.target.value)} required autoComplete="new-password"
                    style={{ width: '100%', padding: '12px', borderRadius: '8px', border: '1px solid #ddd', fontSize: '14px', boxSizing: 'border-box', outline: 'none' }} />
                </div>
                <div style={{ marginBottom: '20px' }}>
                  <label style={{ fontSize: '13px', color: '#666', fontWeight: '600', display: 'block', marginBottom: '6px' }}>Confirmar nova senha</label>
                  <input type="password" placeholder="Repita a senha" value={confirmarSenha}
                    onChange={e => setConfirmarSenha(e.target.value)} required autoComplete="new-password"
                    style={{ width: '100%', padding: '12px', borderRadius: '8px', border: '1px solid #ddd', fontSize: '14px', boxSizing: 'border-box', outline: 'none' }} />
                </div>
                {mensagem && (
                  <div style={{ background: '#FCEBEB', color: '#A32D2D', padding: '10px 14px', borderRadius: '8px', fontSize: '13px', marginBottom: '16px' }}>
                    ❌ {mensagem}
                  </div>
                )}
                <button type="submit" disabled={carregando}
                  style={{ width: '100%', padding: '12px', background: carregando ? '#ccc' : '#1D9E75', color: 'white', border: 'none', borderRadius: '8px', fontSize: '15px', fontWeight: '600', cursor: carregando ? 'not-allowed' : 'pointer' }}>
                  {carregando ? '⏳ Salvando...' : '✅ Redefinir senha'}
                </button>
              </form>
            </>
          )}
        </div>

        <p style={{ textAlign: 'center', color: 'rgba(255,255,255,0.4)', fontSize: '12px', marginTop: '24px' }}>
          Desenvolvido por Digital Mais BR
        </p>
      </div>
    </div>
  );
}

export default RedefinirSenha;